import React, { useEffect, useState } from "react";
import { Loader2, Download } from "lucide-react";
import api from "../../api";

const ACTIONS = [["", "All"], ["plan_change", "Plan changes"], ["suspend", "Suspensions"], ["unsuspend", "Reactivations"], ["password_reset", "Password resets"]];
const BADGE = {
  plan_change: ["Plan change", "bg-[#eef7ff] text-[#2a4a6b]"], suspend: ["Suspended", "bg-red-50 text-red-600"],
  unsuspend: ["Reactivated", "bg-[#dcfce7] text-[#166534]"], password_reset: ["Password reset", "bg-amber-50 text-amber-700"],
};

export default function ActivityLog({ businesses = [] }) {
  const [rows, setRows] = useState(null);
  const [action, setAction] = useState("");
  const [biz, setBiz] = useState("");
  useEffect(() => {
    setRows(null);
    api.get("/admin/activity", { params: { action, business_id: biz } }).then(({ data }) => setRows(data));
  }, [action, biz]);

  const exportCsv = () => {
    const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
    const lines = [["Date", "Action", "Business", "By", "Details"].map(esc).join(",")]
      .concat(rows.map((r) => [r.at, BADGE[r.action]?.[0] || r.action, r.business_name, r.actor, r.details].map(esc).join(",")));
    const url = URL.createObjectURL(new Blob([lines.join("\n")], { type: "text/csv" }));
    const a = document.createElement("a");
    a.href = url; a.download = "activity-log.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  const sel = "rounded-xl border border-gray-200 bg-white px-3 py-2 text-sm";
  return (
    <div className="space-y-4" data-testid="activity-log">
      <div className="flex flex-wrap items-center gap-3">
        <select value={action} onChange={(e) => setAction(e.target.value)} data-testid="activity-filter-action" className={sel}>
          {ACTIONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
        <select value={biz} onChange={(e) => setBiz(e.target.value)} data-testid="activity-filter-business" className={`${sel} max-w-[260px]`}>
          <option value="">All businesses</option>
          {businesses.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
        </select>
        <button onClick={exportCsv} disabled={!rows?.length} data-testid="activity-export" className="ml-auto gp-btn-outline rounded-full px-4 py-2 text-sm font-medium inline-flex items-center gap-1.5 disabled:opacity-40"><Download size={14} /> Export CSV</button>
      </div>
      <div className="bg-white rounded-2xl shadow-[0_8px_24px_rgba(20,30,55,0.06)] overflow-hidden">
        {!rows ? <div className="p-10 flex justify-center"><Loader2 className="animate-spin text-[#2ec9c9]" /></div> : rows.length === 0 ? (
          <p className="p-10 text-center text-sm text-[#8a97a8]" data-testid="activity-empty">No activity recorded yet.</p>
        ) : (
          <table className="w-full text-sm">
            <thead className="text-[#8a97a8] bg-[#f9fafc]"><tr>{["When", "Action", "Business", "By", "Details"].map((h) => <th key={h} className="text-left px-5 py-3 font-medium">{h}</th>)}</tr></thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i} className="border-t border-gray-50" data-testid={`activity-row-${i}`}>
                  <td className="px-5 py-3 text-[#5a6b80] whitespace-nowrap">{new Date(r.at).toLocaleString("en-GB", { dateStyle: "medium", timeStyle: "short" })}</td>
                  <td className="px-5 py-3"><span className={`rounded-full px-2.5 py-1 text-xs font-medium ${BADGE[r.action]?.[1] || ""}`}>{BADGE[r.action]?.[0] || r.action}</span></td>
                  <td className="px-5 py-3 font-medium text-[#16243b]">{r.business_name}</td>
                  <td className="px-5 py-3 text-[#5a6b80]">{r.actor}</td>
                  <td className="px-5 py-3 text-[#5a6b80]">{r.details}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
